import { Link } from "react-router-dom";

export function Logo({ size = 40, withText = true, to = "/" }) {
  const img = (
    <img src="/virtustars-logo.png" alt="VirtuStars" width={size} height={size}
      style={{ height: size, width: "auto", filter: "drop-shadow(0 0 14px rgba(0,229,255,0.25))" }} />
  );
  const inner = (
    <div className="flex items-center gap-2.5 select-none">
      {img}
      {withText && (
        <div className="leading-none">
          <div className="font-display font-extrabold tracking-tight text-[1.05rem]">
            VIRTU<span className="text-gold-grad">STARS</span>
          </div>
        </div>
      )}
    </div>
  );
  return to ? <Link to={to} data-testid="brand-logo">{inner}</Link> : inner;
}
